import {useQueryClient} from '@tanstack/react-query';
import {createApiQuery, useApiMutation} from './api';
import {
  CloneAgent,
  DeleteAgent,
  DownloadPrompts,
  GenerateAnalystAgent,
  GenerateSegmentationAgent,
  PublishAgent,
  SaveAgent,
} from '../../shared/api/definitions/agent';
import {MetadataQueryKey} from '../../context/MetadataContext';
import {GetTeamSizeParams} from '../../shared/api/definitions/root';
import {ObjectId} from 'bson';
import {TaskStatusQueryKeys} from './tasks';

export const useSaveAgent = () => {
  const queryClient = useQueryClient();
  return useApiMutation(SaveAgent, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
};

export const usePublishAgent = () => {
  const queryClient = useQueryClient();
  return useApiMutation(PublishAgent, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
};

export const useDeleteAgent = () => {
  const queryClient = useQueryClient();
  return useApiMutation(DeleteAgent, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
};

export const useCloneAgent = () => {
  const queryClient = useQueryClient();
  return useApiMutation(CloneAgent, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
};

export const useGenerateAnalystAgent = () => {
  const queryClient = useQueryClient();
  return useApiMutation(GenerateAnalystAgent, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: TaskStatusQueryKeys.task('generateAnalystAgent'),
      });
    },
  });
};

export const useGenerateSegmentationAgent = () => {
  const queryClient = useQueryClient();
  return useApiMutation(GenerateSegmentationAgent, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: TaskStatusQueryKeys.task('generateSegmentationAgent'),
      });
    },
  });
};

export const useDownloadPrompts = createApiQuery(
  DownloadPrompts,
  ({agentId, fieldDefinition}) => [
    'agents',
    'prompts',
    agentId.toString(),
    JSON.stringify(fieldDefinition.config),
  ]
);

export const TeamSizeParamsQueryKeys = {
  all: ['agents', 'teamSizeParams'],
  field: (fieldId: ObjectId) => [
    ...TeamSizeParamsQueryKeys.all,
    fieldId.toString(),
  ],
} as const;
export const useGetTeamSizeParams = createApiQuery(
  GetTeamSizeParams,
  ({fieldId}) => TeamSizeParamsQueryKeys.field(fieldId)
);
